import { instance } from './api'

export type UnreadSnapshot = {
  questionTopicIds?: number[]
  competenceId: number
  topics: { topicId: number; unreadCount: number }[]
}

export type UnreadAnchor = { id: number; created: string }

export type TopicReadState = {
  readCreated: string
  readCommentId: number
  firstUnreadComment: UnreadAnchor | null
}

export const forumUnreadAPI = {
  readState: async (topic: number) => (await instance.get<TopicReadState>(`/api/forum/topic/${topic}/read/`)).data,
  snapshot: async (competence: number, personal = false) =>
    (
      await instance.get<UnreadSnapshot>('/api/forum/unread/', {
        params: { competence, ...(personal ? { personal: true } : {}) },
      })
    ).data,
  read: async (topic: number, commentId: number) =>
    (await instance.post<UnreadSnapshot>(`/api/forum/topic/${topic}/read/`, { commentId })).data,
}
